export enum EHttpErrorStatuses {
    error = 'Error',
}
